import {
  Axis,
  AxisOrientation,
  RotationMode,
  RotationOrder,
} from '../generated/index';

/**
 * Configuration for coordinate system transformation in the Imaging API.
 */
export interface CoordinateSystemConfig {
  rotationMode: RotationMode;
  targetUpAxis: Axis;
  targetForwardAxis: Axis;
  targetHandedness: AxisOrientation;
  targetRotationOrder?: RotationOrder;
}

/**
 * Web3D coordinate system configuration for the Imaging API.
 * These values ensure image orientation data is returned in the correct
 * coordinate system for Web3D rendering.
 */
export const WEB3D_COORDINATE_SYSTEM: CoordinateSystemConfig = {
  rotationMode: 'quaternion',
  targetUpAxis: 'Y',
  targetForwardAxis: 'NegZ',
  targetHandedness: 'RightHanded',
  targetRotationOrder: 'Y_P_R',
};

export const IMAGES_PAGE_SIZE = 2000;

/** Page size when listing all datasets for a tenant (list endpoint is paginated). */
export const DATASETS_LIST_PAGE_SIZE = 100;
